module.exports = __webpack_public_path__ + "static/dl2-stay-human_hero-de830ddcfda6aeace0276e5dceac5816.png";